/* __next_internal_client_entry_do_not_use__ SDUIBrandTileWithActionRenderer auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AspectRatioPicture } from "@faire/retailer-visitor-shared/components/Image/AspectRatioPicture";
import { SDUIImage } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Image/SDUIImage";
import { SDUIOnClickHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { SDUIButtonRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Button/SDUIButtonRenderer";
import { getCssFromStyle } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/getCssFromTileStyle";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import React from "react";
var IMAGE_WIDTH = 220;
export var SDUIBrandTileWithActionRenderer = function(param) {
    var tileElement = param.tileElement, loggingData = param.loggingData, renderBehaviour = param.renderBehaviour;
    var on_click = tileElement.on_click, style = tileElement.style;
    var _tileElement_brand_tile_with_action;
    var _ref = (_tileElement_brand_tile_with_action = tileElement.brand_tile_with_action) !== null && _tileElement_brand_tile_with_action !== void 0 ? _tileElement_brand_tile_with_action : {}, brand = _ref.brand, button = _ref.button;
    var _brand_image;
    return /*#__PURE__*/ _jsxs(Column, {
        className: "items-center justify-between",
        style: getCssFromStyle(style),
        children: [
            /*#__PURE__*/ _jsxs(SDUIOnClickHandler, {
                onClickActions: on_click,
                loggingData: loggingData,
                className: "contents",
                logLegacyClickEvent: true,
                children: [
                    /*#__PURE__*/ _jsx(AspectRatioPicture, {
                        $ratio: 1,
                        $width: "100%",
                        children: /*#__PURE__*/ _jsx(SDUIImage, {
                            renderBehaviour: renderBehaviour,
                            responsiveImage: {
                                mobileAndAbove: (_brand_image = brand === null || brand === void 0 ? void 0 : brand.image) !== null && _brand_image !== void 0 ? _brand_image : IImage.build({})
                            },
                            optimizeImageOptions: {
                                width: IMAGE_WIDTH
                            },
                            isProductImage: true
                        })
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        truncate: true,
                        variant: "paragraphSansMedium",
                        className: "w-full !p-4 text-center",
                        children: brand === null || brand === void 0 ? void 0 : brand.name
                    })
                ]
            }),
            button ? /*#__PURE__*/ _jsx(SDUIButtonRenderer, {
                buttonElement: button,
                loggingData: loggingData,
                className: "!mb-4 !w-4/5"
            }) : null
        ]
    });
};
